<template>
  <div
    :class="['filter-button', active && 'active']"
    :style="{ 'padding-right': signSelect ? '10px' : '16px' }"
    @click="click"
  >
    <i v-if="!after" :class="[signSelect ? 'sign-select' : 'large', icon]"></i>
    <span class="title" :style="{ 'padding-left': signSelect ? '0px' : '8px' }">{{ title }}</span>
    <span v-if="cascade && salesNameNum > 0" class="filter-num">({{ salesNameNum }})</span>
    <i v-if="after" :class="[icon, signSelect ? 'sign-select' : 'select-icon']"></i>
    <cascade-select-popup
      v-if="cascade"
      :show="show"
      :options="options"
      :title="filterName"
      :loading="loading"
      :checked="checked"
      @close="close"
      @submit="submit"
    ></cascade-select-popup>
    <single-select-popup
      v-if="!multiple && !cascade"
      :show="show"
      :options="options"
      :title="filterName"
      :checked="checked"
      @close="close"
      @submit="submit"
    />
    <!-- 重构了最左侧集合筛选项 -->
    <filter-seletor v-if="multiple" :show="show" @cancel="close" />
    <!--其他城市商圈选择 -->
    <city-area-select v-if="commonCity" :show="show" @cancel="close" />
    <!--商圈tab城市商圈选择 -->
    <city-area-select-by-area v-if="areaCity" :show="show" @cancel="close" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import cascadeSelectPopup from '@/components-new/popup/cascadeSelectPopup/index.vue'
import singleSelectPopup from '@/components-new/popup/singleSelectPopup/index.vue'
import filterSeletor from '../filterSeletor/index.vue'
import cityAreaSelect from '../cityAreaSelect/index.vue'
import cityAreaSelectByArea from '../cityAreaSelectByArea/index.vue'
const namespace = 'bizopp'
export default {
  components: {
    filterSeletor,
    singleSelectPopup,
    cascadeSelectPopup,
    cityAreaSelect,
    cityAreaSelectByArea,
  },

  props: {
    defaultValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    after: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    areaCity: {
      type: Boolean,
      default: false,
    },
    commonCity: {
      type: Boolean,
      default: false,
    },

    cascade: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    filterName: {
      type: String,
      default: '',
    },
    checked: {
      type: [Number, String, Object],
      default: () => {
        return {}
      },
    },
    signSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { show: false }
  },
  computed: {
    ...mapState(namespace, {
      salesNameNum: state => state.salesNameNum,
    }),
  },
  watch: {
    salesNameNum(nVal) {
      if (nVal > 99) {
        this.updateSalesNameNum(99 + '+')
      }
    },
  },
  methods: {
    ...mapMutations(namespace, [
      'updateSalesNameNum', // 更新销售姓名数量
    ]),
    click() {
      this.show = true
      this.$emit('click')
    },
    close() {
      this.show = false
    },
    submit(value, reset) {
      this.$emit('submit', value, reset)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0 16px;
  white-space: nowrap;
  height: 72px;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 24px;
  margin-right: 16px;
  vertical-align: top;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &.active {
    // background: #fff7f2;

    i,
    .title,
    .filter-num {
      color: #ff7a45;
    }
  }

  .large {
    width: 24px;
    height: 24px;
    font-size: 24px;
    font-weight: 500;
    color: #282b33;
  }
  .sign-select {
    width: 40px;
    height: 40px;
    font-size: 40px;
    font-weight: 500;
    color: #282b33;
  }

  .title {
    font-family: 'DiDiSans-Pro-Regular';
    font-size: 28px;
    color: #282b33;
    text-align: center;
    line-height: 36px;
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // padding-left: 16px;
  }

  .filter-num {
    font-family: 'DiDiSans-Pro-Regular';
    font-size: 28px;
    color: #282b33;
    font-weight: 400;
  }

  .select-icon {
    display: inline-block;
    padding-left: 16px;
    // width: 24px;
    height: 24px;
    font-size: 28px;
    font-weight: 900;
    color: #000;
  }
  // &:first-of-type{
  //  width: 48px !important;
  // }
}
</style>
